export default {
    WEBSITE: 0,
    SOCIAL_MEDIA: 1,
    SOCIAL_MEDIA_INSTAGRAM: 2,
    SOCIAL_MEDIA_TELEGRAM: 3,
    SOCIAL_MEDIA_FACEBOOK: 4,
    SOCIAL_MEDIA_YOUTUBE: 5,
    SOCIAL_MEDIA_TWITTER: 6,
    SOCIAL_MEDIA_OTHER: 7,
}